import { useTheme } from 'lib/context/ThemeContext';
import { IconProps } from '../SvgIcon';

const IconFavorite = (props: IconProps): JSX.Element => {
  const { themeName } = useTheme();
  const { size } = props;
  return themeName === 'aw' ? (
    <svg
      role="img"
      width={size}
      height={size}
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Favorite Icon</title>
      <path
        d="M9.26884 16L8.37389 15.1924C6.83137 13.7808 5.55806 12.5621 4.55397 11.5362C3.54988 10.5102 2.74951 9.59345 2.15288 8.78581C1.55624 7.97817 1.13787 7.24693 0.897761 6.59209C0.657652 5.93724 0.537598 5.27513 0.537598 4.60573C0.537598 3.29604 0.977798 2.201 1.8582 1.3206C2.7386 0.4402 3.82637 0 5.1215 0C5.95097 0 6.71859 0.196453 7.42436 0.589359C8.13014 0.982265 8.74496 1.5498 9.26884 2.29195C9.88003 1.50614 10.5276 0.927694 11.2115 0.556617C11.8955 0.185539 12.6304 0 13.4162 0C14.7113 0 15.7991 0.4402 16.6795 1.3206C17.5599 2.201 18.0001 3.29604 18.0001 4.60573C18.0001 5.27513 17.88 5.93724 17.6399 6.59209C17.3998 7.24693 16.9814 7.97817 16.3848 8.78581C15.7882 9.59345 14.9878 10.5102 13.9837 11.5362C12.9796 12.5621 11.7063 13.7808 10.1638 15.1924L9.26884 16Z"
        fill={props?.fillId ? props.fillId : 'white'}
      />
    </svg>
  ) : (
    <svg width="26" height="22" viewBox="0 0 26 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>Favorite Icon</title>
      <path
        d="M11.9177 20.3996L11.921 20.4029C12.1134 20.5937 12.3416 20.7447 12.5924 20.8471C12.8415 20.9489 13.1081 21.0008 13.377 21C13.646 21.0008 13.9126 20.9489 14.1617 20.8471C14.4125 20.7447 14.6407 20.5937 14.8331 20.4029L14.8364 20.3996L23.0637 12.1617L23.0669 12.1585C24.2842 10.9285 24.967 9.26782 24.967 7.5373C24.967 5.80677 24.2842 4.14613 23.0669 2.91612L23.0669 2.91611L23.0622 2.91144C21.8347 1.68738 20.1719 1 18.4384 1C16.7048 1 15.042 1.68738 13.8145 2.91144L13.8135 2.91244L13.377 3.34889L12.9406 2.91244L12.9396 2.91144C11.7121 1.68738 10.0493 1 8.31573 1C6.5822 1 4.9194 1.68738 3.69187 2.91144L3.69186 2.91142L3.68721 2.91612C2.46992 4.14613 1.78711 5.80677 1.78711 7.5373C1.78711 9.26782 2.46992 10.9285 3.68721 12.1585L3.6872 12.1585L3.69042 12.1617L11.9177 20.3996Z"
        fill={props?.fillId ? props.fillId : 'white'}
        stroke="black"
        strokeWidth="2"
      />
    </svg>
  );
};

export default IconFavorite;
